(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const megaMenus = Array.from(document.querySelectorAll('.mega-menu'));
        if (megaMenus.some((megaMenu) => megaMenu.hasAttribute('open'))) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-old"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  // Sticky ATC Bar
  (function () {
    document.querySelectorAll('[id^="StickyAtcBar-"]').forEach(function (bar) {
      const sectionId = bar.dataset.section;
      const section = document.getElementById('MainProduct-' + sectionId);

      // The original buy_buttons block button (the real ATC button in the page)
      const productBuyButtons = section && section.querySelector('.product__buy-buttons');

      if (!productBuyButtons) return;

      // Show/hide bar based on whether the real ATC is in viewport
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('is-visible');
              bar.setAttribute('aria-hidden', 'true');
            } else {
              bar.classList.add('is-visible');
              bar.setAttribute('aria-hidden', 'false');
            }
          });
        },
        { threshold: 0, rootMargin: '0px' }
      );

      observer.observe(productBuyButtons);

      // ------------------------------------------------------------------
      // Smart click: scroll-to-selector or direct ATC, priority order:
      //   variant picker > subscription selector > bundle selector > simple ATC
      // ------------------------------------------------------------------
      function scrollToElement(el) {
        if (!el) return;
        const offset = 24; // breathing room above the element
        const top = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });

        // Briefly highlight the element so the user knows where to look
        el.classList.add('sticky-atc-bar__scroll-target--highlight');
        setTimeout(function () {
          el.classList.remove('sticky-atc-bar__scroll-target--highlight');
        }, 1400);
      }

      function getScrollTarget() {
        if (!section) return null;

        // 1. Native variant picker (variant-radios or variant-selects)
        const variantPicker =
          section.querySelector('variant-radios') ||
          section.querySelector('variant-selects');
        if (variantPicker) return variantPicker;

        // 2. Subscription selector — common patterns from Recharge, Skio,
        //    Bold, Loop, and generic [data-selling-plan] / .subscription
        const subscriptionTarget =
          section.querySelector('[data-selling-plan-group]') ||
          section.querySelector('[data-selling-plan]') ||
          section.querySelector('.subscription-plans') ||
          section.querySelector('.rc_widget__option') ||        // Recharge
          section.querySelector('[class*="selling-plan"]') ||
          section.querySelector('[id*="selling-plan"]') ||
          section.querySelector('[class*="subscription"]') ||
          section.querySelector('[id*="subscription"]');
        if (subscriptionTarget) return subscriptionTarget;

        // 3. Bundle selector — common patterns from Bundler, Fast Bundle,
        //    Rebundle, and generic [data-bundle] wrappers
        const bundleTarget =
          section.querySelector('[data-bundle]') ||
          section.querySelector('[class*="bundle"]') ||
          section.querySelector('[id*="bundle"]') ||
          section.querySelector('bundle-component') ||
          section.querySelector('[class*="Bundle"]') ||
          section.querySelector('[id*="Bundle"]');
        if (bundleTarget) return bundleTarget;

        // 4. Simple product — no scroll needed, return null
        return null;
      }

      const stickyBtn = bar.querySelector('[id^="StickyAtcBtn-"]');
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          const target = getScrollTarget();

          if (target) {
            // Scroll the user up to the selector they need to interact with
            scrollToElement(target);
          } else {
            // Simple product — submit the real form directly
            const formId = stickyBtn.dataset.productFormId;
            const form = document.getElementById(formId);
            if (form) {
              const submitBtn = form.querySelector('[name="add"]');
              if (submitBtn) {
                submitBtn.click();
              } else {
                form.submit();
              }
            }
          }
        });
      }

      // Keep sticky button state in sync with the real variant selection
      const realSubmitBtn = section && section.querySelector(
        '#' + CSS.escape('product-form-' + sectionId) + ' [name="add"]'
      );
      if (realSubmitBtn && stickyBtn) {
        const syncBtn = function () {
          stickyBtn.disabled = realSubmitBtn.disabled;
          const labelEl = realSubmitBtn.querySelector('[data-label]');
          stickyBtn.textContent = labelEl
            ? labelEl.dataset.label
            : realSubmitBtn.textContent.trim();
        };

        const variantForm = document.getElementById('product-form-' + sectionId);
        if (variantForm) {
          variantForm.addEventListener('change', function () {
            setTimeout(syncBtn, 50);
          });
        }

        const btnObserver = new MutationObserver(syncBtn);
        btnObserver.observe(realSubmitBtn, { attributes: true, childList: true, subtree: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
